export const CurrencySettings = {
    "AFN": {
        "name": "Afghan afghani",
        "symbol": "؋",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "EUR": {
        "name": "Euro",
        "symbol": "€",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "ALL": {
        "name": "Albanian lek",
        "symbol": "L",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "DZD": {
        "name": "Algerian dinar",
        "symbol": "د.ج",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "USD": {
        "name": "United States dollar",
        "symbol": "$",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ",",
        "decimalSeparator": "."
    },
    "AOA": {
        "name": "Angolan kwanza",
        "symbol": "Kz",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "XCD": {
        "name": "East Caribbean dollar",
        "symbol": "$",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "AUD": {
        "name": "Australian dollar",
        "symbol": "$",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ",",
        "decimalSeparator": "."
    },
    "GBP": {
        "name": "British pound",
        "symbol": "£",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ",",
        "decimalSeparator": "."
    },
    "ARS": {
        "name": "Argentine peso",
        "symbol": "$",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "AMD": {
        "name": "Armenian dram",
        "symbol": null,
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "AWG": {
        "name": "Aruban florin",
        "symbol": "ƒ",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "AZN": {
        "name": "Azerbaijani manat",
        "symbol": null,
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "BSD": {
        "name": "Bahamian dollar",
        "symbol": "$",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "BHD": {
        "name": "Bahraini dinar",
        "symbol": ".د.ب",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "BDT": {
        "name": "Bangladeshi taka",
        "symbol": "৳",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ",",
        "decimalSeparator": "."
    },
    "BBD": {
        "name": "Barbadian dollar",
        "symbol": "$",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "BYN": {
        "name": "New Belarusian ruble",
        "symbol": "Br",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "BYR": {
        "name": "Old Belarusian ruble",
        "symbol": "Br",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "BZD": {
        "name": "Belize dollar",
        "symbol": "$",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "XOF": {
        "name": "West African CFA franc",
        "symbol": "Fr",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "BMD": {
        "name": "Bermudian dollar",
        "symbol": "$",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "BTN": {
        "name": "Bhutanese ngultrum",
        "symbol": "Nu.",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "INR": {
        "name": "Indian rupee",
        "symbol": "₹",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ",",
        "decimalSeparator": "."
    },
    "BOB": {
        "name": "Bolivian boliviano",
        "symbol": "Bs.",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "BAM": {
        "name": "Bosnia and Herzegovina convertible mark",
        "symbol": null,
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "BWP": {
        "name": "Botswana pula",
        "symbol": "P",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "NOK": {
        "name": "Norwegian krone",
        "symbol": "kr",
        "position": "right",
        "decimals": 2,
        "thousandSeparator": ",",
        "decimalSeparator": "."
    },
    "BRL": {
        "name": "Brazilian real",
        "symbol": "R$",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "null": {
        "name": null,
        "symbol": null,
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "BND": {
        "name": "Brunei dollar",
        "symbol": "$",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "SGD": {
        "name": "Singapore dollar",
        "symbol": "$",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ",",
        "decimalSeparator": "."
    },
    "BGN": {
        "name": "Bulgarian lev",
        "symbol": "лв",
        "position": "right",
        "decimals": 2,
        "thousandSeparator": " ",
        "decimalSeparator": ","
    },
    "BIF": {
        "name": "Burundian franc",
        "symbol": "Fr",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "KHR": {
        "name": "Cambodian riel",
        "symbol": "៛",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "XAF": {
        "name": "Central African CFA franc",
        "symbol": "Fr",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "CAD": {
        "name": "Canadian dollar",
        "symbol": "$",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ",",
        "decimalSeparator": "."
    },
    "CVE": {
        "name": "Cape Verdean escudo",
        "symbol": "Esc",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "KYD": {
        "name": "Cayman Islands dollar",
        "symbol": "$",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "CLP": {
        "name": "Chilean peso",
        "symbol": "$",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "CNY": {
        "name": "Chinese yuan",
        "symbol": "¥",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ",",
        "decimalSeparator": "."
    },
    "COP": {
        "name": "Colombian peso",
        "symbol": "$",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "KMF": {
        "name": "Comorian franc",
        "symbol": "Fr",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "CDF": {
        "name": "Congolese franc",
        "symbol": "Fr",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "NZD": {
        "name": "New Zealand dollar",
        "symbol": "$",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ",",
        "decimalSeparator": "."
    },
    "CKD": {
        "name": "Cook Islands dollar",
        "symbol": "$",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "CRC": {
        "name": "Costa Rican colón",
        "symbol": "₡",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "HRK": {
        "name": "Croatian kuna",
        "symbol": "kn",
        "position": "right",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "CUC": {
        "name": "Cuban convertible peso",
        "symbol": "$",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "CUP": {
        "name": "Cuban peso",
        "symbol": "$",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "ANG": {
        "name": "Netherlands Antillean guilder",
        "symbol": "ƒ",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "CZK": {
        "name": "Czech koruna",
        "symbol": "Kč",
        "position": "right",
        "decimals": 2,
        "thousandSeparator": " ",
        "decimalSeparator": ","
    },
    "DKK": {
        "name": "Danish krone",
        "symbol": "kr",
        "position": "right",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "DJF": {
        "name": "Djiboutian franc",
        "symbol": "Fr",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "DOP": {
        "name": "Dominican peso",
        "symbol": "$",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "EGP": {
        "name": "Egyptian pound",
        "symbol": "£",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "ERN": {
        "name": "Eritrean nakfa",
        "symbol": "Nfk",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "ETB": {
        "name": "Ethiopian birr",
        "symbol": "Br",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "FKP": {
        "name": "Falkland Islands pound",
        "symbol": "£",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "(none)": {
        "name": null,
        "symbol": null,
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "FJD": {
        "name": "Fijian dollar",
        "symbol": "$",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "XPF": {
        "name": "CFP franc",
        "symbol": "Fr",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "GMD": {
        "name": "Gambian dalasi",
        "symbol": "D",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "GEL": {
        "name": "Georgian Lari",
        "symbol": "ლ",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "GHS": {
        "name": "Ghanaian cedi",
        "symbol": "₵",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "GIP": {
        "name": "Gibraltar pound",
        "symbol": "£",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "GTQ": {
        "name": "Guatemalan quetzal",
        "symbol": "Q",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "GNF": {
        "name": "Guinean franc",
        "symbol": "Fr",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "GYD": {
        "name": "Guyanese dollar",
        "symbol": "$",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "HTG": {
        "name": "Haitian gourde",
        "symbol": "G",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "HNL": {
        "name": "Honduran lempira",
        "symbol": "L",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "HKD": {
        "name": "Hong Kong dollar",
        "symbol": "$",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "HUF": {
        "name": "Hungarian forint",
        "symbol": "Ft",
        "position": "right",
        "decimals": 2,
        "thousandSeparator": " ",
        "decimalSeparator": ","
    },
    "ISK": {
        "name": "Icelandic króna",
        "symbol": "kr",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "IDR": {
        "name": "Indonesian rupiah",
        "symbol": "Rp",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "IRR": {
        "name": "Iranian rial",
        "symbol": "﷼",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "IQD": {
        "name": "Iraqi dinar",
        "symbol": "ع.د",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "IMP[G]": {
        "name": "Manx pound",
        "symbol": "£",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "ILS": {
        "name": "Israeli new sheqel",
        "symbol": "₪",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "JMD": {
        "name": "Jamaican dollar",
        "symbol": "$",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "JPY": {
        "name": "Japanese yen",
        "symbol": "¥",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ",",
        "decimalSeparator": "."
    },
    "JEP[G]": {
        "name": "Jersey pound",
        "symbol": "£",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "JOD": {
        "name": "Jordanian dinar",
        "symbol": "د.ا",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "KZT": {
        "name": "Kazakhstani tenge",
        "symbol": null,
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "KES": {
        "name": "Kenyan shilling",
        "symbol": "Sh",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "KWD": {
        "name": "Kuwaiti dinar",
        "symbol": "د.ك",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "KGS": {
        "name": "Kyrgyzstani som",
        "symbol": "с",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "LAK": {
        "name": "Lao kip",
        "symbol": "₭",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "LBP": {
        "name": "Lebanese pound",
        "symbol": "ل.ل",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "LSL": {
        "name": "Lesotho loti",
        "symbol": "L",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "ZAR": {
        "name": "South African rand",
        "symbol": "Rs",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": " ",
        "decimalSeparator": ","
    },
    "LRD": {
        "name": "Liberian dollar",
        "symbol": "$",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "LYD": {
        "name": "Libyan dinar",
        "symbol": "ل.د",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "CHF": {
        "name": "Swiss franc",
        "symbol": "Fr",
        "position": "right",
        "decimals": 2,
        "thousandSeparator": ",",
        "decimalSeparator": "."
    },
    "MOP": {
        "name": "Macanese pataca",
        "symbol": "P",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "MKD": {
        "name": "Macedonian denar",
        "symbol": "ден",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "MGA": {
        "name": "Malagasy ariary",
        "symbol": "Ar",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "MWK": {
        "name": "Malawian kwacha",
        "symbol": "MK",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "MYR": {
        "name": "Malaysian ringgit",
        "symbol": "RM",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ",",
        "decimalSeparator": "."
    },
    "MVR": {
        "name": "Maldivian rufiyaa",
        "symbol": ".ރ",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "MRO": {
        "name": "Mauritanian ouguiya",
        "symbol": "UM",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "MUR": {
        "name": "Mauritian rupee",
        "symbol": "₨",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "MXN": {
        "name": "Mexican peso",
        "symbol": "$",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ",",
        "decimalSeparator": "."
    },
    "MNT": {
        "name": "Mongolian tögrög",
        "symbol": "₮",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "MAD": {
        "name": "Moroccan dirham",
        "symbol": "د.م.",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "MZN": {
        "name": "Mozambican metical",
        "symbol": "MT",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "MMK": {
        "name": "Burmese kyat",
        "symbol": "Ks",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "NAD": {
        "name": "Namibian dollar",
        "symbol": "$",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "NPR": {
        "name": "Nepalese rupee",
        "symbol": "₨",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "NIO": {
        "name": "Nicaraguan córdoba",
        "symbol": "C$",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "NGN": {
        "name": "Nigerian naira",
        "symbol": "₦",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "KPW": {
        "name": "North Korean won",
        "symbol": "₩",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "OMR": {
        "name": "Omani rial",
        "symbol": "ر.ع.",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "PKR": {
        "name": "Pakistani rupee",
        "symbol": "₨",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "PAB": {
        "name": "Panamanian balboa",
        "symbol": "B/.",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "PGK": {
        "name": "Papua New Guinean kina",
        "symbol": "K",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "PYG": {
        "name": "Paraguayan guaraní",
        "symbol": "₲",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "PEN": {
        "name": "Peruvian sol",
        "symbol": "S/.",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "PHP": {
        "name": "Philippine peso",
        "symbol": "₱",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "PLN": {
        "name": "Polish złoty",
        "symbol": "zł",
        "position": "right",
        "decimals": 2,
        "thousandSeparator": " ",
        "decimalSeparator": ","
    },
    "QAR": {
        "name": "Qatari riyal",
        "symbol": "ر.ق",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "RON": {
        "name": "Romanian leu",
        "symbol": "lei",
        "position": "right",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "RUB": {
        "name": "Russian ruble",
        "symbol": "₽",
        "position": "right",
        "decimals": 2,
        "thousandSeparator": " ",
        "decimalSeparator": ","
    },
    "RWF": {
        "name": "Rwandan franc",
        "symbol": "Fr",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "SHP": {
        "name": "Saint Helena pound",
        "symbol": "£",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "WST": {
        "name": "Samoan tālā",
        "symbol": "T",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "STD": {
        "name": "São Tomé and Príncipe dobra",
        "symbol": "Db",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "SAR": {
        "name": "Saudi riyal",
        "symbol": "ر.س",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "RSD": {
        "name": "Serbian dinar",
        "symbol": "дин.",
        "position": "right",
        "decimals": 2,
        "thousandSeparator": " ",
        "decimalSeparator": ","
    },
    "SCR": {
        "name": "Seychellois rupee",
        "symbol": "₨",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "SLL": {
        "name": "Sierra Leonean leone",
        "symbol": "Le",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "SBD": {
        "name": "Solomon Islands dollar",
        "symbol": "$",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "SOS": {
        "name": "Somali shilling",
        "symbol": "Sh",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "KRW": {
        "name": "South Korean won",
        "symbol": "₩",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ",",
        "decimalSeparator": "."
    },
    "SSP": {
        "name": "South Sudanese pound",
        "symbol": "£",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "LKR": {
        "name": "Sri Lankan rupee",
        "symbol": "Rs",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "SDG": {
        "name": "Sudanese pound",
        "symbol": "ج.س.",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "SRD": {
        "name": "Surinamese dollar",
        "symbol": "$",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "SZL": {
        "name": "Swazi lilangeni",
        "symbol": "L",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "SEK": {
        "name": "Swedish krona",
        "symbol": "kr",
        "position": "right",
        "decimals": 2,
        "thousandSeparator": " ",
        "decimalSeparator": ","
    },
    "SYP": {
        "name": "Syrian pound",
        "symbol": "£",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "TWD": {
        "name": "New Taiwan dollar",
        "symbol": "$",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "TJS": {
        "name": "Tajikistani somoni",
        "symbol": "ЅМ",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "TZS": {
        "name": "Tanzanian shilling",
        "symbol": "Sh",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "THB": {
        "name": "Thai baht",
        "symbol": "฿",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ",",
        "decimalSeparator": "."
    },
    "TOP": {
        "name": "Tongan paʻanga",
        "symbol": "T$",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "TTD": {
        "name": "Trinidad and Tobago dollar",
        "symbol": "$",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "TND": {
        "name": "Tunisian dinar",
        "symbol": "د.ت",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "TRY": {
        "name": "Turkish lira",
        "symbol": "₺",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "TMT": {
        "name": "Turkmenistan manat",
        "symbol": "m",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "TVD[G]": {
        "name": "Tuvaluan dollar",
        "symbol": "$",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "UGX": {
        "name": "Ugandan shilling",
        "symbol": "Sh",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "UAH": {
        "name": "Ukrainian hryvnia",
        "symbol": "₴",
        "position": "right",
        "decimals": 2,
        "thousandSeparator": " ",
        "decimalSeparator": ","
    },
    "AED": {
        "name": "United Arab Emirates dirham",
        "symbol": "د.إ",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "UYU": {
        "name": "Uruguayan peso",
        "symbol": "$",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "UZS": {
        "name": "Uzbekistani so'm",
        "symbol": null,
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "VUV": {
        "name": "Vanuatu vatu",
        "symbol": "Vt",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "VEF": {
        "name": "Venezuelan bolívar",
        "symbol": "Bs F",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "VND": {
        "name": "Vietnamese đồng",
        "symbol": "₫",
        "position": "right",
        "decimals": 2,
        "thousandSeparator": ",",
        "decimalSeparator": "."
    },
    "YER": {
        "name": "Yemeni rial",
        "symbol": "﷼",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "ZMW": {
        "name": "Zambian kwacha",
        "symbol": "ZK",
        "position": "left",
        "decimals": 2,
        "thousandSeparator": ".",
        "decimalSeparator": ","
    },
    "default": {
        "pos": "right",
        "icon": false,
        "thousandSeparator": ",",
        "decimalSeparator": ".",
        "decimals": 2,
    },
};
